module.exports = __webpack_public_path__ + "static/functions-screen-9-5c85f786b8e762026f6539fb52204e58.png";